import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

interface IProps {
    href?: string
    children: any
}

const PrivateRoute = ({ href = '/login', children }: IProps) => {
    const { isLoggedIn } = useAuth()
    return isLoggedIn ? children : <Navigate to={href} />
}

export default PrivateRoute